import endpointDuckFactory from "./_endpointDuckFactory";

export const countriesDuck = endpointDuckFactory({ endpoint: "countries" });
